module.exports = __webpack_public_path__ + "static/media/screening_image004.55ff5013.png";